import api from './api.js';
import { Tab } from './scripts/tabs/tab.js';
import { TabButton } from './scripts/tabs/tab-button.js';
import { TabsGroup } from './scripts/tabs/tabs-group';

api.Tab = Tab;
api.TabButton = TabButton;
api.TabsGroup = TabsGroup;

export default api;
